import {
  generateFunnelPath,
  isQAAppEnvironment,
  removeVersionFromPath,
} from '@wkda/funnel-utils';
/**
 * @typedef {import('@wkda/internal-types').ISelfEvaluationAppConfig} ISelfEvaluationAppConfig
 * @typedef {import('@wkda/internal-types').IBookingAppConfig} IBookingAppConfig
 * @typedef {import('@wkda/internal-types').ICarleadCreationAppConfig} ICarleadCreationAppConfig
 * @typedef {{routePathSchema?: string} & (ISelfEvaluationAppConfig | IBookingAppConfig | ICarleadCreationAppConfig)} IAppConfig
 */

/**
 * @param {Array<any>} routes
 * @param {IAppConfig} config
 */
export function buildRoutes(routes, config) {
  const generated = routes.flatMap((route) => {
    return buildRoute(route, config);
  });

  return generated;
}

/**
 * @param {{path?: string;}} route
 * @param {IAppConfig} config
 */
function buildRoute(route, config) {
  if (route.path === undefined) {
    return route;
  }
  const { path, ...restRoute } = route;
  let routes = [{ path: `${generateFunnelPath(config)}${path}`, ...restRoute }];
  if (isQAAppEnvironment(config.env)) {
    routes.push({
      path: config.routePathSchema
        ? `${generateFunnelPath(config, false)}${path}`
        : `${removeVersionFromPath(generateFunnelPath(config))}${path}`,
      ...restRoute,
    });
  }
  return routes;
}
